import { createTheme, MantineColorsTuple } from '@mantine/core';

// Anchor #00AEFF matches the existing onboarding `.btn` background
// (source/stylus/onboarding/includes/components/button.styl) at Mantine's
// default `filled` shade (index 6), so primary Buttons match legacy CTAs
// without per-call colour overrides.
const artcloudBlue: MantineColorsTuple = [
    '#E0FAFF', '#CAF1FF', '#99E2FF', '#64D2FF', '#3BC4FE',
    '#23BBFE', '#00AEFF', '#009BE4', '#0089CC', '#0076B5',
];

// scale: 1.6 compensates for legacy `html { font-size: 62.5% }` in
// source/stylus/core/reset.styl. Without it Mantine's rem-based sizing
// renders at 62.5% of intended.
export const mantineTheme = createTheme({
    scale: 1.6,
    fontFamily: "'Public Sans', sans-serif",
    headings: { fontFamily: "Inter, sans-serif" },
    primaryColor: 'artcloud-blue',
    colors: { 'artcloud-blue': artcloudBlue },
    defaultRadius: 'md',
});
